export default {
  welcome: {
    your_language: 'Your language',
    language_to_learn: 'Language you want to learn',
    start_learning: 'Start learning',
    how_does_this_work: 'How does this work?',
    welcome_1: 'Welcome to JAALUU',
    welcome_2: 'Here you can learn languages',
    welcome_3: 'Read texts or view videos with subtitles',
    welcome_4: 'Click on a word for translations, examples and definitions',
    main_teaser: 'Improve your language skills - easily and for free',
    hero_headline: 'Stop memorizing lists. Start speaking fluently with AI-powered immersion',
    hero_subheadline:
      'Jaaluu uses real-world content, personalized chatbot conversations, and spaced repetition to help you master a new language in minutes a day.',
    hero_cta: 'Start Learning for Free',
    select_language_and_start: 'Select language and start',
    how_to_title: 'Read texts, books, news, or watch videos',
    how_to_text: 'You can choose from a variety of texts, books, news, or videos',
    click_on_word_title: 'Automatic translation, examples, and definitions',
    click_on_word_text:
      'Click on any word for automatic translation, example sentences, and definitions. You can also translate whole sentences automatically or link words with images and create word networks.',
    listen_title: 'Listen to words and texts',
    listen_text: 'You can listen to any word, sentence, or entire texts and practice pronunciation',
    conversations_title: 'Practice conversations',
    conversations_text:
      'You can practice conversations by talking to a virtual chatbot. You need to solve tasks like: `Order food in a restaurant` or `Ask for directions.`',
    writing_title: 'Spelling',
    writing_text_1: 'Practice spelling by writing texts',
    writing_text_2: 'Your texts will be checked for spelling mistakes, content, and grammar.',
    texts_and_videos_title: 'Find your level',
    texts_and_videos_text:
      'You can choose between simple phrases and texts for children, news, Wikipedia articles, or books, whatever suits you best',
    srs_title: 'Repeat and train vocabulary',
    srs_text_1: 'You can save any word or entire sentences as favorites to repeat later',
    srs_text_2:
      'Train your vocabulary with flashcards and simple exercises, and track your progress',
    srs_text_3:
      'The SRS repetition system helps you learn more effectively by repeating words at the right time',
    own_text_title: 'Specialized vocabulary',
    own_text_text:
      'You can create text on a specific topic to learn special vocabulary. You can also create texts containing words you want to learn.',
    wordmap_title: 'Word networks',
    wordmap_text_1: 'You can create word networks and link words with simple sentences',
    wordmap_text_2:
      'Word cards can be saved as favorites, allowing for easy repetition and training',
    sayings_title: 'Idioms',
    sayings_text:
      'Here you will find commonly used phrases and idioms, categorized. You can track your progress and continue to develop in a structured way.',
    details: 'Details',
    details_text_and_videos_title:
      'Discover Jaaluu – Your key to fast and effective language learning!',
    details_text_and_videos_text:
      'Jaaluu offers you a wealth of texts and videos to improve your language level. The platform is ideal if you can already understand simple words and sentences. For beginners, there are simple phrases and idioms, texts for children, lexicons, and videos for an easy start. For advanced learners, there are news, Wikipedia articles, books, and exciting videos for deeper understanding, or interactive chatbot conversations. Additionally, you can train your spelling and get tips to improve spelling mistakes, content, and grammar.',
    details_click_on_words_title:
      'Learning vocabulary made easy: Fast, interactive, and sustainable!',
    details_click_on_words_text:
      'Learning vocabulary can be tedious because looking up words and definitions takes a lot of time. Jaaluu solves this problem: Just click on a word to instantly get translations, example sentences, definitions, and explanations. This saves time and helps you learn faster and more effectively!',
    details_listen_title:
      'Listen and practice: Hear words, sentences, and texts to improve your language skills!',
    details_listen_text:
      'You can hear everything – any word, any sentence, or even entire texts. Just play and listen! This feature helps you practice correct pronunciation and improve listening comprehension. You can also listen to conversations and develop a feel for natural communication. Perfect for internalizing vocabulary and strengthening your language skills in everyday situations.',
    details_conversations_title:
      'Practical language training: Realistic conversations for everyday life!',
    details_conversations_text:
      'With Jaaluu, you can practice realistic conversations with a chatbot and prepare for typical everyday situations. For example, you can order food in a restaurant and pay the bill or ask for directions. Or, you can chat with your new colleague on your first day in a new job. Your sentences will be automatically analyzed to give you direct feedback and improve your language skills. This way, you train in a practical and effective manner for real conversations!',
    details_writing_title:
      'Writing practice for everyday life: Improve your skills with realistic tasks!',
    details_writing_text:
      'You can practice writing by mastering small, realistic tasks, such as writing applications or complaint letters. Your text will then be automatically analyzed, and you will receive direct feedback on spelling, content, and grammar. This way, you improve your writing skills and are well-prepared for everyday life!',
    details_srs_title:
      'Effective vocabulary learning with SRS: Automatic repetitions and personalized progress analysis!',
    details_srs_text:
      'With the SRS system (Spaced Repetition System), you can learn and repeat vocabulary effectively. This system reminds you when to repeat words in order to retain them long-term. SRS is based on the scientific method that repeating at certain intervals strengthens memory. You will also receive statistics on the learning progress of each word and your success rate, so you can focus on your weaknesses and always know how well you are progressing in vocabulary learning.',
    details_own_text_title:
      'Personalized learning: Create custom texts for targeted vocabulary and topic exercises!',
    details_own_text_text:
      "With Jaaluu, you can easily create your own texts in areas you want to focus on. Describe the area or vocabulary you want to learn, and you'll get a text to read and practice. This way, you can concentrate on specific topics or vocabulary and expand your knowledge in the area that matters to you. This tailored approach helps you learn more effectively and precisely! Additionally, you can create texts that contain all the vocabulary you want to review. This allows you to learn and review vocabulary in context, making it easier to remember.",
    details_wordmap_title: 'Word cards: Connect your knowledge and remember words with ease!',
    details_wordmap_text:
      'You can create word cards that help you network words and remember them more effectively. Add words and sentences interactively to your word card and gradually expand your vocabulary. This creates and strengthens connections in your brain and builds associations playfully. This way, you enhance your language understanding – sustainably!',
    details_paste_text_title: 'Use your own texts: Paste your content to learn with focus!',
    details_paste_text_text:
      'With Jaaluu, you can also paste your own texts to use them for practice. This allows you to work with your own material and train your vocabulary in real-life contexts.',
    explore_more: 'Explore more from Jaaluu',
    site_also_available: 'The site is also available in',
    which_languages_title: 'Which languages can I learn?',
    which_languages_text:
      'Here you can learn Spanish, French, Italian, German, Portuguese, Russian, and Polish. Simply select the language you want to learn and you´re ready to go!'
  },
  intro: {
    your_level: 'What is your language level?',
    beginner_explained: 'You can read simple sentences',
    intermediate_explained: 'You can read simple texts and articles',
    advanced_explained: 'You can read more complex texts',
    your_cefr_level: 'Your CEFR level is',
    lets_start: 'Lets start with?',
    intermediate_options: {
      simple_texts: 'Read texts',
      simple_articles: 'Read articles',
      sayings: 'Learn sayings',
      simple_phrases: 'Read typical sentences',
      klexikon: "Read Klexikon (Children's Encyclopedia)"
    },
    advanced_options: {
      news: 'Read news',
      wikipedia: 'Read articles',
      books: 'Read books',
      conversations: 'Practice conversations',
      writing: 'Practice writing'
    }
  },
  languages: {
    de: 'German',
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    it: 'Italian',
    pt: 'Portuguese',
    ru: 'Russian',
    zh: 'Chinese',
    pl: 'Polish'
  },
  general: {
    close: 'Close',
    home: 'Home',
    beginner: 'Beginner',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    search: 'Search',
    what_to_read: 'What would you like to read?',
    search_imperative: 'Search',
    translate: 'Translate',
    what_you_want_to_translate: 'What do you want to translate from {from} to {to}?',
    word_not_found: 'Word "{word}" does not seem to exist.',
    similar_words_found: 'I found the most similar words:',
    settings: 'Settings',
    vocabulary: 'Vocaublary',
    most_important_words: '{n} most important words',
    learn_most_important_words: 'Learn the 500 most important words',
    continue_with_word: 'Continue with word {n}',
    jokes: 'Jokes',
    n_jokes: '{n} jokes',
    learn_jokes: 'Learn 200 jokes',
    continue_with_joke: 'Continue with joke {n}',
    shorts: 'Short texts',
    articles: 'Articles',
    feeds: 'News',
    videos: 'Videos',
    read: 'Read',
    view: 'View',
    listen: 'Listen',
    save: 'Save',
    more: 'more',
    back: 'Back',
    next: 'Next',
    continue_with_sentence: 'Continue with sentence {sentenceIdx}',
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
    all: 'All',
    level: 'Level',
    font_size: 'Font size',
    language: 'Language',
    send: 'Send',
    image: 'Image',
    wordmap: 'Wordmap',
    open: 'Open',
    add: 'Add',
    question: 'Question',
    start: 'Start',
    continue: 'Continue',
    words: 'Word | Words',
    points: 'Point | Points',
    repeat: 'Repeat',
    test: 'Test',
    nothing_found: 'Nothing found',
    skip: 'Skip',
    congratulations: 'Congratulations',
    well_done: 'Well done!',
    try_again: 'Try again',
    finish: 'Finish',
    total: 'Total',
    synapsis_score: 'Synapsis Score',
    synapsis_milestone: 'Synapsis score milestone! New score: {score}',
    fun_facts: 'Fun Facts about {country}',
    fun_facts_missing_points: 'Points to next fun fact about {country}',
    fun_facts_previous: 'Previous fun facts ({count})',
    fun_fact_unlocked: 'You can now view a new fun fact about {country}',
    finished_units: 'Unit | Units',
    finished_course_chapters: 'Course chapter | Course chapters',
    grammar_chapters: 'Grammar chapter | Grammar chapters',
    completed: 'Completed',
    turn: 'Turn'
  },
  app_bar: {
    search_in_foreign_language: 'Search in foreign language',
    menu: 'Menu'
  },
  category: {
    chapter: 'Chapter',
    learn_most_common_pre: 'Learn the most common',
    learn_most_common_post: 'from many different categories',
    or_choose_a_category: 'Choose a category:',
    chapter_end: 'You reached the end of this chapter!',
    phrases: 'Phrases',
    sayings: 'Sayings',
    simple_texts: 'Texts',
    conversations: 'Conversations',
    write: 'Writing',
    course: 'Course'
  },
  favorites: {
    favorites: 'Favorites',
    word: 'Word',
    sentence: 'Sentence',
    sentences: 'Sentences',
    texts: 'Texts',
    wordmaps: 'Wordmaps',
    saved: 'Saved',
    title: 'Title',
    type: 'Type',
    word_type: 'Word type',
    no_favorites_found: 'No favorites found',
    filtered_by: 'filtered by',
    train: 'Train',
    train_words: 'Train {wordCount} words',
    notify_me_srs: 'Notify me to repeat vocabulary with SRS',
    action_sounds: 'Action Sounds',
    srs_level: 'SRS Level',
    success_rate: 'Success Rate',
    translation: 'Translation',
    context: 'Context',
    last_seen: 'Last time seen',
    next_review: 'Next review',
    short_story: 'Short story',
    success_level_up: 'Word moved to level {level}',
    success_level_up_celebrate: 'Word {word} moved to the next level!',
    what_is_srs: 'What is SRS?',
    srs_short:
      'SRS is a spaced repetition system. It helps you to remember words better by repeating them at the right time.',
    srs_long:
      'The system is based on the principle that the more often you repeat a word, the better you remember it. The intervals between repetitions are determined by the system. If you remember a word well, the intervals become longer. If you have difficulties, the intervals become shorter. This way you can learn words more efficiently.',
    srs_intervals: 'The {nIntervals} intervals are: {intervals} days.',
    when_does_a_word_move: 'When does a word move to the next level?',
    srs_next_level_example_1:
      'If you add a word to the favorites, it will be on level 1. A word on level 1 will go to the next level if 1 day passed since you added the word, your success rate is higher than 50% and you just remembered the word correctly.',
    srs_next_level_example_2:
      'A word on level {level} will go to the next level after the last change to level {levelM1} was at least {days} days ago, your success rate is higher than 50% and you just remembered the word correctly.',
    favorite_group: 'Gruppe',
    group_already_exists: 'A folder with that name already exists',
    cannot_delete_default: 'The `Default` folder cannot be deleted',
    group_still_has_words:
      'The folder still contains favorites. Please delete all favorites first.',
    group_deleted: 'Folder deleted'
  },
  player: {
    maximize: 'Maximize',
    minimize: 'Minimize'
  },
  video: {
    error:
      'There was an error loading the subtitles. Unfortunately, not all subtitles are freely accessible. Please try another video.',
    subtitles: 'Subtitles'
  },
  feeds: {
    disclaimer:
      'This is an automatically generate summary by Chatgpt. The original article is available',
    here: 'here',
    generating_article: 'Generating article...',
    error:
      'There was an error loading the article. Unfortunately, not all articles are freely accessible. Please try another article or copy the text manually',
    open_org: '1. Open original article and copy text',
    open_own: '2. Paste text here'
  },
  books: {
    read_now: 'Read now',
    continue_on_page: 'Continue on page'
  },
  tooltip: {
    examples: 'Examples',
    emotional_examples: 'Emotional Examples',
    definition: 'Definition',
    base_word: 'Base Word',
    synonyms: 'Synonyms',
    antonyms: 'Antonyms',
    article: 'Article',
    conjugations: 'Conjugation',
    grammer: 'Grammar',
    etymology: 'Etymology',
    all_meanings: 'All meanings',
    context: 'Context'
  },
  custom_text: {
    enter_your_own_text: 'Enter your own text',
    read_text: 'Read text',
    enter_new_text: 'Enter new text',
    own_text: 'Copy your own text and paste it here',
    special_vocabulary: 'Special vocabulary'
  },
  special_vocabulary: {
    special_vocabulary: 'Special vocabulary',
    explanation:
      'Here you can create a new text about a topic which you would like to study. A text will be generated which you can use for studying.',
    describe: 'Enter a text in english about a topic or special vocabulary you want to learn',
    language_level: 'Language level',
    generate_text: 'Generate text'
  },
  custom_vocabulary: {
    custom_vocabulary: 'Custom Vocabulary',
    add_new_category: 'Add new category',
    title: 'Title',
    description: 'Which vocabulary do you want to learn?',
    description_placeholder: 'Describe the vocabulary you want to learn',
    description_example: "Example: 'Numbers from 1 to 20'",
    number_of_words: 'Number of vocabularies',
    generate: 'Generate',
    no_lists_found: 'No custom vocabulary lists yet',
    list_not_found: 'This vocabulary list was not found',
    error_generating: 'There was an error generating the vocabulary. Please try again.',
    home_teaser: 'Create your own vocabulary lists on any topic you want to learn',
    n_lists: 'custom list | custom lists'
  },
  live_conversations: {
    start_conversation: 'Start Conversation',
    end_conversation: 'End Conversation',
    connecting: 'Connecting…',
    connected: 'Conversation in progress…',
    microphone_error:
      'Could not start the conversation. Please check your microphone access and try again.',
    not_found: 'This conversation was not found',
    reviewing: 'Reviewing your conversation…',
    transcript_title: 'Your conversation',
    no_turns: 'No conversation was recorded.',
    no_mistakes: 'No mistakes found — well done!',
    review_unavailable: 'The review could not be loaded. Please try again later.'
  },
  intro_message: {
    save_word_as_fav: 'Save the word as favorite',
    save_video_as_fav: 'Save the video as favorite',
    save_article_as_fav: 'Save the article as favorite',
    save_book_as_fav: 'Save the book as favorite',
    save_wordmap_as_fav: 'Save the word map as favorite',
    play_word: 'Listen to the pronunciation of the word',
    play_article: 'Listen to the article',
    play_book: 'Listen to the book',
    select_main_category: 'Select a main category',
    select_sub_category: 'Select a subcategory',
    click_on_read: 'Click on `READ` to read the full text',
    click_on_view: 'Click on `WATCH` to watch a video',
    wordmap_click_on_word: 'Click on the word to see the most frequently used words',
    wordmap_click_on_line: 'Click on a line between two words to see a sentence',
    conversations_select_scene: 'Select an exercise',
    conversations_warn:
      'It seems there is an error in your sentence. Click on the triangle for more explanations.',
    conversations_task: 'Formulate a sentence based on the following instructions:'
  },
  tour_guide: {
    click_on_every_word: {
      title: 'Translate Word',
      text: 'You can click on any word to see translations, example sentences and definitions'
    },
    click_on_i_for_sentence: {
      title: 'Full Sentence',
      text: 'To translate an entire sentence, click on the i-symbol. Here you can also get explanations about grammar.'
    },
    no_save_custom: {
      title: 'No saving',
      text: 'Custom text can not be saved'
    },
    change_playback_rate: {
      title: 'Change Playback Speed',
      text: 'Change the playback speed via Menu/Settings/Audio and Video.'
    },
    theme: {
      title: 'Colors',
      text: 'You can change the colors in the menu to dark mode'
    },
    repeat_words: {
      title: 'Repeat Vocabulary',
      text: 'You should repeat {nWords} vocabularies.',
      call_to_action: 'Learn now'
    },
    flipcards: {
      title: 'Flip Cards',
      text: 'Turn the card and click on the happy or sad face to track your progress'
    },
    synapsis_score: {
      title: 'Synapsis Score',
      text: 'You earn points for each word, weighted by its level, and additional points for every completed chapter or unit'
    }
  },
  chat: {
    your_message: 'Your message',
    waiting_for_teacher: 'Waiting for teacher...',
    in_de: 'in German',
    in_en: 'in English',
    in_es: 'in Spanish',
    in_fr: 'in French',
    in_it: 'in Italian',
    in_pt: 'in Portuguese',
    in_ru: 'in Russian',
    in_zh: 'in Chinese',
    in_pl: 'in Polish',
    wait: 'Please wait...',
    speak_now: 'Speak now',
    new_chat: 'New chat',
    switch_language: 'Switch language',
    language_teacher: 'Language Teacher',
    summarize_mistakes: 'Summarize Mistakes'
  },
  langs: {
    de: 'German',
    en: 'English',
    sp: 'Spanish',
    fr: 'French',
    it: 'Italian',
    pt: 'Portuguese',
    pl: 'Polish',
    ru: 'Russian',
    zh: 'Chinese'
  },
  countries: {
    de: 'Germany',
    en: 'England',
    es: 'Spain',
    fr: 'France',
    it: 'Italy',
    pt: 'Portugal',
    pl: 'Poland',
    ru: 'Russia',
    zh: 'China'
  },
  about: {
    how_does_it_work: 'How does it work?',
    here_you_can: 'Here you can',
    read_texts: 'Read texts',
    watch_videos: 'Watch videos',
    click_on_every_wrord_for: 'Click on any word for',
    translations: 'translations',
    examples: 'examples',
    definitions: 'definitions',
    synonyms: 'synonyms',
    copy_your_own_text: 'Copy and read your own text',
    chat_with_chatbot: 'Chat with a chatbot',
    level: 'Your level should be between B1 and C2'
  },
  settings: {
    audio_video: 'Audio and Video',
    level: 'Level',
    colors: 'Color',
    dark_mode: 'Dark mode',
    lang_level: 'Language level',
    show_pinyin: 'Show pinyin',
    show_translation: 'Show translation'
  },
  error: {
    resource_not_found: 'Sorry, we could not find what you are looking for'
  },
  train: {
    check: 'Check',
    flashcards: 'Flashcards',
    exercises: 'Exercises',
    finished: 'Exercises finished',
    go_to_favorites: 'Go to favorites',
    restart_exercise: 'Restart exercise',
    go_to_home: 'Go to home',
    text_with_words: 'Text with words',
    text_includes: 'The text includes all the words you want to learn',
    generate_audio: 'Generate audio',
    stop_audio: 'Stop audio'
  },
  wordmap: {
    click_on_circle: 'Click on the circle to see the most frequently used words with {word}',
    click_on_edge: 'Click on the line between two words to see a sentence with both words',
    open_fullscreen: 'Open Wordmap in fullscreen',
    add_own_word: 'Add own word',
    add_sentence_with_all_words: 'Add sentence with all words',
    add_to_word: 'Add to word'
  },
  conversations: {
    you_are: 'You are',
    you_talk_to: 'You talk to',
    your_tasks: 'Your tasks'
  },
  write: {
    min_words: 'Minimum words',
    your_email_needs_to_contain: 'Your email needs to contain',
    rate: 'Rate',
    analysis: 'Analysis',
    overall: 'Overall',
    grammar: 'Grammar',
    content: 'Content',
    spelling: 'Spelling',
    passed: 'Well done! You passed this exercise.',
    failed: 'Keep practicing! Your score was not enough to pass.',
    restart: 'Try again'
  },
  cookies: {
    title: 'This website uses cookies',
    description:
      "We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services.",
    description_short:
      'We use cookies to personalise content and ads, to provide social media features and to analyse our traffic...',
    deny: 'Deny',
    allow_selection: 'Allow selection',
    clear_local_storage: 'Clear local storage keys',
    clear_local_storage_confirm: 'Are you sure you want to remove selected local storage keys?',
    clear_local_storage_success: 'Selected local storage keys have been removed.',
    tooltip_necessary:
      'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
    tooltip_preferences:
      'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.',
    tooltip_statistics:
      'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
    tooltip_marketing:
      'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.'
  },
  grammar: {
    menu_title: 'Grammar',
    start_grammar_lessons: 'Start Grammar Lessons',
    loading: 'Loading grammar menu...',
    error_loading: 'Failed to load grammar menu',
    retry: 'Retry',
    no_content: 'No grammar content available',
    chapter: 'Chapter',
    loading_lesson: 'Loading lesson...',
    error_loading_lesson: 'Failed to load lesson',
    overview: 'Overview',
    detailed_explanation: 'Detailed Explanation',
    core_rules: 'Core Rules',
    examples: 'Examples',
    common_mistakes: 'Common Mistakes',
    exceptions: 'Exceptions',
    variations: 'Variations',
    practice_exercises: 'Practice Exercises',
    question: 'Question',
    check_answer: 'Check Answer',
    correct_answer_feedback: 'Correct! Well done.',
    incorrect_answer_feedback: 'Incorrect. The correct answer is:',
    rule: 'Rule',
    exercise: 'Exercise',
    results: 'Results',
    passed: 'Well done! You passed!',
    failed: 'Keep practicing! You did not pass.',
    lesson_completed: 'Grammar lesson completed!'
  },
  course: {
    chapter_completed: 'Course chapter completed!'
  },
  transcription: {
    title: 'Live Transcription',
    subtitle: 'Listen to a conversation and see it written on screen as you speak',
    start: 'Start Transcription',
    stop: 'Stop',
    listening: 'Listening…',
    transcribing: 'Transcribing…',
    mic_settings_title: 'Microphone settings',
    mic_mode_close: 'Close speech',
    mic_mode_distant: 'Distant / playback audio',
    mic_boost_label: 'Mic boost',
    mic_settings_hint: 'Applies the next time you start listening',
    mic_level_label: 'Mic input level',
    mic_level_clipping: 'Too loud',
    mic_test_start: 'Test microphone',
    mic_test_stop: 'Stop test',
    empty_state: 'Tap "Start Transcription" and start talking - what is said will appear here',
    not_supported:
      'Live transcription is not supported in this browser. Please make sure microphone access is available.',
    microphone_error:
      'Could not access the microphone. Please check your microphone permissions and try again.',
    transcription_error: 'Could not transcribe that part. Still listening…',
    copied: 'Transcript copied to clipboard'
  },
  video_object_detection: {
    title: 'Video Object Detection',
    subtitle:
      'Point your camera at objects around you and see what they are called in the language you are learning',
    start: 'Start Video',
    stop: 'Stop',
    scanning: 'Scanning…',
    empty_state: 'Tap "Start Video" and point your camera at objects to see them labeled here',
    not_supported: 'Camera access is not supported in this browser. Please try Chrome or Edge.',
    camera_error: 'Could not access the camera. Please check your camera permissions and try again.',
    detected_words: 'Detected words',
    nearby_objects: 'Other objects nearby — tap to add'
  }
};
